var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKitchen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44575 19.2506H4.31323V12.7977C4.31323 12.6492 4.5301 12.5277 4.79516 12.5277H9.44575V19.2506V19.2506Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5783 12.5277H9.4458V19.2506H14.5783V12.5277Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6867 19.2506H14.5542V12.5277H19.2048C19.4699 12.5277 19.6867 12.6492 19.6867 12.7977V19.2506Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.792 13.2748H10.3583V13.7085H10.792V13.2748Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2168 13.2748H11.7831V13.7085H12.2168V13.2748Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42809 14.4916H7.99435V14.9253H8.42809V14.4916Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6416 13.2748H13.2079V13.7085H13.6416V13.2748Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0178 14.4916H15.5841V14.9253H16.0178V14.4916Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59033 14.6242H14.7229",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59033 12.5277H14.7229",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9197 10.0771C16.9197 9.50576 17.3127 9.05347 17.8092 9.05347C18.3057 9.05347 18.6987 9.50576 18.6987 10.0771V12.2321",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7652 8.51716H8.96436V7.61004L10.4742 6.10022V4.74939H13.2554V6.10022L14.7652 7.61004V8.51716Z",
    stroke: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.ff57dcc0859ecdc2b6355291d12f11f9.svg";
export { ForwardRef as ReactComponent };